import React, { useState, useEffect, useCallback } from 'react';
import { CpDropdown, CpIcon } from 'canopy-styleguide!sofe';
import { DateTime } from 'luxon';
import { isRole, hasLicense } from './user-guiding.helper';

import styles from './nav-profile.styles.css';
import { useNav } from '../../nav.context';

let checklist;
const userGuiding = window.userGuiding;
const userGuidingLayer = window.userGuidingLayer;

export function NavLearning() {
  const nav = useNav();
  const [checkListOpen, setChecklistOpen] = useState(false);

  useEffect(() => {
    if (!nav.user || !window.userGuiding) return;
    const loggedInUser = nav.user;
    const userGuidingTrackAttributes = {
      new_user: loggedInUser.created_at > 1597104000000, // May 11th, 12am UTC
      days_since_last_login: DateTime.fromMillis(loggedInUser.lastLogin)?.diffNow()?.days || 0,
      license_firm_management: hasLicense(loggedInUser, 'firmManagement'),
      license_practice_management: hasLicense(loggedInUser, 'practiceManagement'),
      license_practice_management_pro: hasLicense(loggedInUser, 'practiceManagementPro'),
      license_client_management: hasLicense(loggedInUser, 'clientManagement'),
      license_document_management: hasLicense(loggedInUser, 'documentManagement'),
      license_time_and_billing: hasLicense(loggedInUser, 'timeAndBilling'),
      license_workflow: hasLicense(loggedInUser, 'workflow'),
      license_tax_resolution: hasLicense(loggedInUser, 'taxResolution'),
      license_transcripts: hasLicense(loggedInUser, 'transcripts'),
      license_notices: hasLicense(loggedInUser, 'irsNotices'),
      role_sales: isRole(loggedInUser.email, 'sales'),
      role_success: isRole(loggedInUser.email, 'success'),
      role_support: isRole(loggedInUser.email, 'support'),
      role_sdr: isRole(loggedInUser.email, 'sdr'),
    };
    //all attributes passed to track need to be passed to identify in order for segmentation to work properly
    window.userGuiding?.track('segment', userGuidingTrackAttributes);
    window.userGuiding?.identify(loggedInUser.id, {
      name: loggedInUser.name,
      email: loggedInUser.email,
      accessLevel: loggedInUser.accessLevel,
      ...userGuidingTrackAttributes,
    });
  }, [nav.user, JSON.stringify(window.userGuiding?.track)]);

  useEffect(() => {
    if (!nav.user || !window.userGuiding) return;
    checklist = userGuiding
      ? userGuiding.getFromAppStore('checklists')?.find(checklist => {
          return userGuiding.segmentsMatch(checklist.data);
        })
      : false;

    if (userGuiding && userGuiding.hideChecklist) userGuiding.hideChecklist();
    if (userGuidingLayer) {
      userGuidingLayer.push({
        event: 'onPreviewEnd',
        fn: () => {
          setChecklistOpen(true);
          userGuiding.launchChecklist(checklist.id, { itemsShown: true });
        },
      });
    }
    return () => {
      document.removeEventListener('click', onDocClick);
    };
  }, [nav.user, JSON.stringify(window.userGuiding?.track)]);

  useEffect(() => {
    if (checkListOpen) {
      document.addEventListener('click', onDocClick);
    } else {
      document.removeEventListener('click', onDocClick);
    }
  }, [checkListOpen]);

  const onDocClick = useCallback(e => {
    if (!doesContain(e.target, 'userguiding-assistant-container')) {
      setChecklistOpen(false);
      if (userGuiding) {
        userGuiding.hideChecklist();
      }
    }
  }, []);

  function openChecklist(e) {
    e.stopPropagation();
    setChecklistOpen(true);
    userGuiding.launchChecklist(checklist.id, { itemsShown: true });
  }

  return (
    <CpDropdown
      position="right-end"
      triggerIsBlock
      className={styles.wrapper}
      contentWidth={240}
      onOpen={() => {
        if (nav.secondaryOpen) {
          nav.setSecondaryOpen(null);
        }
      }}
      renderTrigger={({ toggle }) => (
        <a className={styles.wrapper} onClick={toggle}>
          <div className={styles.learningButton}>
            <CpIcon name="misc-grad-cap" />
          </div>
        </a>
      )}
      renderContent={() => (
        <div className="cp-select-list cp-select-list__primary-menu">
          {checklist && (
            <button onClick={openChecklist}>
              <div className="cp-select-list__content">In-App Guides</div>
            </button>
          )}
          <a href="https://www.getcanopy.com/courses" target="_blank" rel="noreferrer noopener">
            <div className="cp-select-list__content">CPE and CE Courses</div>
            <CpIcon name="caret-large-right" className="cp-select-list__icon-right" />
          </a>
          <a href="https://www.getcanopy.com/training" target="_blank" rel="noreferrer noopener">
            <div className="cp-select-list__content">Product Tutorials</div>
            <CpIcon name="caret-large-right" className="cp-select-list__icon-right" />
          </a>
        </div>
      )}
    />
  );
}

function doesContain(child, className) {
  if (!child || !child.classList) return false;
  if (child.classList.contains(className)) return true;
  return doesContain(child.parentNode, className);
}
